(function () {
  'use strict';

  var storageKey = 'zivvi-collagen-serum-scratch-v3';
  var revealEvent = 'zivvi:scratch-revealed';

  function setProgress(root, value) {
    var progress = root.querySelector('[data-zivvi-scratch-progress]');
    var normalized = Math.max(0, Math.min(100, Math.round(value)));
    if (progress) progress.textContent = normalized >= 100 ? 'Revealed' : normalized + '% revealed';
  }

  function finish(root, options) {
    if (!root || root.classList.contains('is-revealed')) return;
    var settings = options || {};
    var card = root.querySelector('[data-zivvi-scratch-card]');
    var prize = root.querySelector('[data-zivvi-scratch-prize]');
    var hint = root.querySelector('[data-zivvi-scratch-hint]');

    root.classList.add('is-revealed');
    setProgress(root, 100);
    if (card) {
      card.setAttribute('aria-pressed', 'true');
      card.setAttribute('aria-label', 'Free Collagen Boosting Serum revealed');
    }
    if (prize) prize.setAttribute('aria-hidden', 'false');
    if (hint) hint.textContent = 'Your free serum is unlocked and included with your order.';

    if (settings.persist !== false) {
      try {
        window.localStorage.setItem(root.dataset.storageKey || storageKey, 'true');
      } catch (error) {
        // The reveal remains usable when browser storage is unavailable.
      }
    }

    if (settings.broadcast !== false) {
      document.dispatchEvent(new CustomEvent(revealEvent, {
        detail: { storageKey: root.dataset.storageKey || storageKey }
      }));
    }
  }

  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var card = root.querySelector('[data-zivvi-scratch-card]');
    var canvas = root.querySelector('[data-zivvi-scratch-canvas]');
    var context = canvas && canvas.getContext('2d');
    var active = false;
    var lastPoint = null;
    var distance = 0;
    var brushSize = 44;

    if (!card || !canvas || !context) return;

    function drawCover() {
      if (root.classList.contains('is-revealed')) return;
      var rect = card.getBoundingClientRect();
      var width = Math.max(1, Math.round(rect.width));
      var height = Math.max(1, Math.round(rect.height));
      var pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
      var texture = new Image();

      canvas.width = Math.round(width * pixelRatio);
      canvas.height = Math.round(height * pixelRatio);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      context.globalCompositeOperation = 'source-over';
      brushSize = Math.max(36, Math.min(54, width * .09));
      distance = 0;
      setProgress(root, 0);

      texture.crossOrigin = 'anonymous';
      texture.onload = function () {
        if (root.classList.contains('is-revealed')) return;
        var imageRatio = texture.width / texture.height;
        var cardRatio = width / height;
        var sourceWidth = texture.width;
        var sourceHeight = texture.height;
        var sourceX = 0;
        var sourceY = 0;

        if (imageRatio > cardRatio) {
          sourceWidth = texture.height * cardRatio;
          sourceX = (texture.width - sourceWidth) / 2;
        } else {
          sourceHeight = texture.width / cardRatio;
          sourceY = (texture.height - sourceHeight) / 2;
        }

        context.drawImage(texture, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, width, height);
        context.fillStyle = 'rgba(93, 53, 5, .18)';
        context.fillRect(0, 0, width, height);
        context.fillStyle = '#4b2b08';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = '900 ' + (width < 420 ? '17px' : '20px') + ' Arial, sans-serif';
        context.fillText('SCRATCH TO REVEAL', width / 2, height / 2 - 9);
        context.font = '700 11px Arial, sans-serif';
        context.fillText('A FREE $89 GIFT IS WAITING', width / 2, height / 2 + 18);
      };
      texture.onerror = function () {
        context.fillStyle = '#d5a72d';
        context.fillRect(0, 0, width, height);
      };
      texture.src = root.dataset.textureUrl;
    }

    function point(event) {
      var rect = canvas.getBoundingClientRect();
      return { x: event.clientX - rect.left, y: event.clientY - rect.top };
    }

    function erase(from, to) {
      if (!from || !to) return;
      context.globalCompositeOperation = 'destination-out';
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.lineWidth = brushSize;
      context.beginPath();
      context.moveTo(from.x, from.y);
      context.lineTo(to.x, to.y);
      context.stroke();
    }

    function updateProgress() {
      var rect = card.getBoundingClientRect();
      var cardArea = Math.max(1, rect.width * rect.height);
      var percent = Math.min(100, distance * brushSize * .72 / cardArea * 100);
      setProgress(root, percent);
      if (percent >= 46) finish(root);
    }

    canvas.addEventListener('pointerdown', function (event) {
      if (root.classList.contains('is-revealed')) return;
      active = true;
      lastPoint = point(event);
      erase(lastPoint, lastPoint);
      if (canvas.setPointerCapture) canvas.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    canvas.addEventListener('pointermove', function (event) {
      if (!active || root.classList.contains('is-revealed')) return;
      var nextPoint = point(event);
      var deltaX = nextPoint.x - lastPoint.x;
      var deltaY = nextPoint.y - lastPoint.y;
      distance += Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      erase(lastPoint, nextPoint);
      lastPoint = nextPoint;
      updateProgress();
      event.preventDefault();
    });

    function endScratch() {
      active = false;
      lastPoint = null;
      updateProgress();
    }

    canvas.addEventListener('pointerup', endScratch);
    canvas.addEventListener('pointercancel', endScratch);
    canvas.addEventListener('pointerleave', endScratch);

    card.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        finish(root);
      }
    });

    document.addEventListener(revealEvent, function (event) {
      if (event.detail && event.detail.storageKey === (root.dataset.storageKey || storageKey)) {
        finish(root, { persist: false, broadcast: false });
      }
    });

    try {
      if (window.localStorage.getItem(root.dataset.storageKey || storageKey) === 'true') {
        finish(root, { persist: false, broadcast: false });
      } else {
        drawCover();
      }
    } catch (error) {
      drawCover();
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (!root.classList.contains('is-revealed')) drawCover();
      }).observe(card);
    }
  }

  function initAll(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-zivvi-pdp-scratch]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  window.ZivviPdpScratch = { initAll: initAll };
})();
